import { Typo } from 'components/typography/Typo';
import { databasesSteps } from 'layouts/AuthorizedWithLeftMenu/Breadcrumbs';
import Header, { TitleProps } from 'layouts/AuthorizedWithLeftMenu/Header';
import { getStringDividedByDot } from 'services/strings';
import styles from './index.module.css';

interface WashedSampleProps {
	state: {
		instance_name: string;
		table_name: string;
		table_schema_name: string;
		type: string;
	} | null;
	id: string;
}

function WashedSample({ id, state }: WashedSampleProps) {
	let titleBlock: TitleProps['children'];

	if (state) {
		titleBlock = state.table_schema_name
			? `${state.table_schema_name}.${state.table_name}`
			: state.table_name;
	} else {
		titleBlock = `Database sample with ID ${id}`;
	}

	return (
		<>
			<Header>
				<Header.Breadcrumbs steps={databasesSteps} finalStep="Sample" />

				<Header.Title>{titleBlock}</Header.Title>
				{state && (
					<Header.Subtitle>
						{getStringDividedByDot(state.instance_name, state.type)}
					</Header.Subtitle>
				)}
			</Header>

			<Typo variant="D/Regular/Body-S" color="secondary" className={styles.noSample}>
				No data available, as the table have not been found during the last scan.
			</Typo>
		</>
	);
}

export type { WashedSampleProps };
export { WashedSample };
